export default __webpack_public_path__ + "static/media/Electronic Cigarettes.98114778.png";